import { applyInputState } from '../../forms/input';
import { Municipality, Province, Region } from '../../locations';
import Logger from '../../logging/logger';
import PropertySearchFilter from '../../property/filters';
import getIcon from '../../svgs';
import { removeAreaState } from '../area';
import { getSourceFeatures } from '../features';
import SearchThisArea from './search-this-area';

class RemoveArea {
    constructor( mapSearch, options = {} ) {
        this.mapSearch = mapSearch;
        this.options = options;
        this.state = {
            locationID: null,
            locationFreeText: null,
        };
    }

    init( map ) {
        const controlContainer = document.querySelector( '.twc__map-search-control-container-bottom' );

        if ( !controlContainer ) {
            return;
        }

        this.map = map;

        this.container = document.createElement( 'div' );
        this.container.className = 'removearea__container';
        this.container.style.display = 'none';

        const initialSearchFilter = PropertySearchFilter.fromURLSearchParams( new URLSearchParams( window.location.search ) );

        if ( initialSearchFilter.area.length > 0 && initialSearchFilter.viewMode !== SearchThisArea.id ) {
            this.container.style.display = '';
        }

        this.btn = document.createElement( 'button' );
        this.btn.type = 'button';
        this.btn.className = 'twc__map-search-item removearea__btn';
        this.btn.innerHTML = getIcon( 'closeX', 'font' ) + this.mapSearch.getTemplateString( 'btnClearArea' );
        this.btn.title = this.mapSearch.getTemplateString( 'btnClearArea' );
        this.btn.addEventListener( 'click', this._onClick.bind( this ) );

        this.container.appendChild( this.btn );

        controlContainer.appendChild( this.container );

        this.mapSearch.on( 'twc:mapsearch:show-remove-search-area', this._onShow.bind( this ) );
        this.mapSearch.on( 'twc:mapsearch:hide-remove-search-area', this._onHide.bind( this ) );
        this.mapSearch.on( 'twc:mapsearch:remove-search-area', this._onClick.bind( this ) );
    }

    _onClick() {
        removeAreaState( this.map );

        this.container.style.display = 'none';

        const filter = PropertySearchFilter.fromForm( this.mapSearch.baseForm );

        if ( !this.map.getLayer( `${Region}:fill` ) && !this.map.getLayer( `${Province}:fill` ) && !filter.anyLocationFilters() ) {
            this.btn.dispatchEvent( new CustomEvent( 'twc:mapsearch:reset', {
                bubbles: true,
                detail: {
                    searchOptions: {
                        resetLayers: true,
                        focusMapToSearch: false,
                    },
                },
            } ) );
            return;
        }

        if ( this.state.locationID && this.state.locationID.value === SearchThisArea.id ) {
            this.state = {
                locationID: null,
                locationFreeText: null,
            };

            this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:search-this-area:activate', {
                bubbles: true,
            } ) );
            return;
        }

        if ( filter.anyLocationFilters() ) {
            getSourceFeatures( this.map, Municipality ).forEach( ( m ) => {
                this.map.setFeatureState(
                    {
                        source: Municipality,
                        id: m.id,
                    },
                    {
                        active: true,
                    },
                );
            } );
        }

        const isLocation = ( this.state.locationID && parseInt( this.state.locationID.value ) > 0 );
        const locationID = document.querySelector( '#property-search-form-base input[name=locationId]' );
        const locationFreeText = document.querySelector( '#property-search-form-base input[name=locationFreeText]' );

        if ( ( isLocation || filter.anyLocationFilters() ) && locationID && locationFreeText ) {
            applyInputState( locationID, this.state.locationID );
            applyInputState( locationFreeText, this.state.locationFreeText );
        }

        this.mapSearch.baseForm.dispatchEvent( new CustomEvent( 'twc:mapsearch:form-submit', {
            bubbles: true,
            detail: {
                focusMapToSearch: false,
                resetLayers: false,
                recalculateBboxAfterAnimation: true,
            },
        } ) );

        this.state = {
            locationID: null,
            locationFreeText: null,
        };
    }

    _onHide() {
        Logger.info( '[map] Hiding Remove Search Area Button' );

        this.state = {
            locationID: null,
            locationFreeText: null,
        };

        this.container.style.display = 'none';
    }

    _onShow( event ) {
        Logger.info( '[map] Showing Remove Search Area Button' );

        const { locationID, locationFreeText } = event.detail;

        this.state.locationID = locationID;
        this.state.locationFreeText = locationFreeText;

        this.container.style.display = '';
    }
}

export default RemoveArea;
